//# sourceMappingURL=jwt.mjs.map
/// <reference types="./jwt.d.mts" />
import * as $dynamic from "../../gleam_stdlib/gleam/dynamic.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import { toList } from "../gleam.mjs";
import { permissions as read_permissions } from "./jwt.ffi.mjs";

export function permissions(token) {
  let _pipe = token;
  let _pipe$1 = read_permissions(_pipe);
  let _pipe$2 = $result.unwrap(_pipe$1, $dynamic.string(""));
  let _pipe$3 = $decode.run(_pipe$2, $decode.list($decode.string));
  return $result.unwrap(_pipe$3, toList([]));
}
